import { ProjectViewModel } from '../../../../../config/configs';
import { assertNeverForViewMode, OnlineStudentViewModes, StudentViewMode } from '../../../../../config/constants';
import { ApiClient } from '@ael/core-api';

export async function getProjectViewModelFromServer(
  viewMode: OnlineStudentViewModes,
  apiClient: ApiClient,
  projectGuid: string
) {
  const response = await _getProjectViewModelResponse(viewMode, apiClient, projectGuid);
  switch (response.status) {
    case 200: {
      const viewModel: ProjectViewModel = await response.json();
      return viewModel;
    }
    default:
      assertNever(response.status);
  }
}

async function _getProjectViewModelResponse(viewMode: OnlineStudentViewModes, apiClient: ApiClient, guid: string) {
  switch (viewMode) {
    case StudentViewMode.Preview:
      return apiClient['/api/editor/get-project/editor-preview/{courseGuid}'].get({
        params: {
          courseGuid: guid,
        },
      });
    case StudentViewMode.SCORM:
      return apiClient['/api/editor/get-project/dispatched-scorm/{courseGuid}'].get({
        params: {
          courseGuid: guid,
        },
      });
    case StudentViewMode.Basic:
      return apiClient['/api/editor/get-project/ael-student/{courseGuid}'].get({
        params: {
          courseGuid: guid,
        },
      });
    case StudentViewMode.Public:
      return apiClient['/api/editor/get-project/public/{guid}'].get({
        params: {
          guid: guid,
        },
      });
    default:
      return assertNeverForViewMode(viewMode);
  }
}

function assertNever(statusCode: number): never {
  throw new Error('Unexpected status code ' + statusCode + ' when retrieving project data.');
}
